export const KoLocale = {
    page: {
        txtTitle: 'SHIRITORI | 재미있는 しらとり 게임으로 온라인 일본어 어휘를 쉽게 배우세요',
    },
    common: {
        txtLogoAlt: 'Shiritori 기차',
    },
    header: {
        txtLeave: '게임 나가기',
    },
    dialog: {
        leave: {
            txtTitle: '이 게임에서 나갈까요?',
            btnStay: '게임에 남기',
            btnLeave: '나가서 기권하기',
        },
    },
    home: {
        btnNewGame: '새 게임',
        btnMainMenu: '메인 메뉴',
        btnJoinGame: '참가',
        btnReturnToGame: '게임으로 돌아가기',
    },
    create: {
        headingNamePrompt: '어떻게 불러드릴까요?',
        placeholderName: '이름',
        btnOk: '확인',
    },
    join: {
        placeholderName: '이름',
        placeholderGameId: '게임 ID',
        btnJoinGame: '참가',
    },
    configure: {
        header: '게임 설정',
        labelExpectedPlayers: '플레이어 수',
        labelBoardSize: '보드 크기',
        labelWordList: '단어 목록',
        labelAllowHints: '힌트 허용',
        labelTurnTimer: '턴 타이머',
        optionNoTimer: '타이머 없음',
        optionTimer: '타이머',
        unitSeconds: '초',
        btnStartGame: '시작',
        toastCreateError: '오류: 이 게임을 만들 수 없습니다',
        toastTryAgain: '오류: 나중에 다시 시도해 주세요.',
    },
    game: {
        lobby: {
            btnReady: '준비 완료',
            txtShareInvite: '이 코드를 친구들과 공유하세요!',
            txtPlayer: '플레이어',
            txtTeam: '팀',
        },
        message: {
            noSuchGame: '존재하지 않는 게임입니다',
            txtLoading: '불러오는 중...',
            txtCannotJoin: '게임에 참가할 수 없습니다',
        },
        gameplay: {
            board: {
                timeoutTitle: '시간',
                timeoutSubtitle: '초과',
            },
            wordSearch: {
                multipleMatches: '여러 결과가 발견되었습니다!',
                yourTurn: '당신의 차례',
                placeholder: '어떤 단어를 낼까요?',
                playAction: '내기',
                timerSeconds: '{{seconds}}초',
                toastNoSuchWord: '그런 단어가 없어요!',
                toastCantPlay: '그 단어는 낼 수 없어요!',
                toastPlayed: '"{{word}}" 제출됨',
                toastPlayFailed: '앗, 그 단어를 낼 수 없었습니다!',
                validation: {
                    syllableMismatch: '시작 음절이 맞지 않습니다',
                    missingLastWord: '이전 턴에 단어가 없습니다',
                    wordNotInList: '선택한 목록에 없는 단어입니다',
                }
            },
            spectate: {
                waitingOn: '{{player}} 대기 중',
                timeLeft: '남은 시간: {{seconds}}초',
            },
            endGame: {
                header: '게임 종료',
                viewResults: '결과 보기',
                statsTotalTime: '총 플레이 시간',
                statsSquaresFilled: '채워진 칸 수',
                statsLongestWord: '가장 긴 단어',
                share: '공유',
                sharing: '공유 중...',
                ariaCloseLabel: '게임 종료 모달 닫기',
            }
        },
    },
    footer: {
        linkHowToPlay: '플레이 방법',
        linkPrivacyPolicy: '개인정보처리방침',
        txtAllRightsReserved: 'All Rights Reserved.',
    },
    howToPlay: {
        title: 'Shiritori しりとり (shiritori) 플레이 방법',
        btnPlayNow: '지금 플레이!',
        btnReturnToGame: '게임으로 돌아가기:',
        description1: 'b|Shiritori| 는 일본어 단어 잇기 게임 しりとり를 온라인 멀티플레이로 즐길 수 있게 만든 버전입니다. 친구와 함께 또는 혼자 어휘를 연습하며 그림 보드를 완성해 보세요.',
        description2: '게임을 만들거나 참가하고, 보드 크기/그림 세트/단어 목록을 고른 뒤, 누군가 실수하기 전에 유효한 단어로 격자를 채우는 속도전을 펼치세요.',
        gameSetup: {
            title: '게임 만들기 또는 참가하기',
            p1: '혼자 시작하거나 공유 링크/게임 코드로 최대 9명의 친구(총 10명)를 초대할 수 있습니다.',
            p2: '원하는 옵션을 선택하세요: 보드 크기(3x3, 5x5, 7x7), 배경 패턴/색상, 그림 세트, 학습할 단어 목록.',
            p3: '친구가 링크를 열고 닉네임을 고르면 로비에 표시되며, 예상 인원이 모이면 게임이 시작됩니다.',
            p4: '늦게 온 사람도 관전 전용 모드로 진행 중인 경기를 볼 수 있습니다.',
        },
        objective: {
            title: '목표',
            p1: '이전 단어의 마지막 음절로 다음 단어를 이어 보드를 채우고, 단어를 ん으로 끝내지 마세요.',
        },
        wordRules: {
            title: '유효한 단어',
            p1: '가나 또는 로마자로 입력할 수 있으며, 로마자는 검사 전에 클라이언트에서 히라가나로 변환됩니다.',
            p2: '단어는 선택한 목록(상용 100/1000, 음식, 스포츠 등)에 있어야 하며, 제출 후 뜻이 표시됩니다.',
            p3: '이미 사용한 단어는 막힙니다. 동음이의어 허용 규칙이 켜져 있으면, 올바른 그림이 있는 미사용 변형을 고를 수 있습니다.',
            li1: '이전 턴에서 요구한 음절로 시작해야 함',
            li2: 'ん (n)으로 끝나면 안 됨',
            li3: '선택한 단어 목록에 포함되어야 함',
            li4: '이 게임에서 이전에 사용되지 않았어야 함',
            li5: '해당 규칙이 켜진 경우 허용된 동음이의어/그림을 사용해야 함',
            p4: '유효한 플레이마다 그림이 순서대로 보드에 놓이며, 왼쪽에서 오른쪽, 위에서 아래로 채워집니다. e|예시:_そば_→_バス|',
        },
        turnFlow: {
            title: '턴과 시간',
            p1: '턴은 플레이어 목록 순서로 돌아가며, 자신의 차례가 보이는 순간부터 최대 10초가 주어집니다.',
            p2: 'Shiritori 는 다음 플레이어가 활성 상태(브라우저 포커스)일 때까지 카운트다운을 시작하지 않아, 재시작/새로고침으로 타이머를 건너뛸 수 없습니다.',
            p3: '단어를 입력하고 실시간 검증을 확인한 뒤 제한 시간 안에 제출하세요. 무효 또는 지연 제출은 즉시 경기 종료입니다.',
        },
        boardFlow: {
            title: '보드, 진행, 종료',
            p1: '보드에는 제출된 단어의 그림, 플레이어 이름, 턴 번호가 표시되고, 화살표로 격자 내 진행 순서를 보여줍니다.',
            p2: '다른 사람 차례일 때도 필요한 시작 음절과 남은 시간을 볼 수 있습니다.',
            p3: '모든 칸이 유효한 단어로 채워지면 게임이 성공적으로 끝나고, 완성된 보드를 공유할 수 있습니다.',
            p4: '시간이 끝나기 전에 유효한 단어가 제출되지 않으면, 누가 시간 초과/무효 단어를 냈는지 요약과 함께 게임이 종료됩니다.',
        },
        summary: {
            title: '요약',
            p1: 'Shiritori 는 짧은 라운드, 명확한 규칙, 그림 연상으로 shiritori를 빠르고 시각적으로 즐기게 해 줍니다.',
            p2: '링크를 공유하고 보드를 채우며, 단어 체인이 어디까지 이어지는지 확인해 보세요.',
        }
    },
    bugsAndFeatures: {
        title: '버그 제보 및 신규 기능',
        p1: '이 게임은 클래식 k|しりとり.| 를 색다르게 즐기기 위해 만들었습니다. 게임을 사랑하는 팀으로서, 더 재미있게 만들 방법을 항상 찾고 있습니다.',
        cta: {
            l1: '가능하다면 ',
            a: '친구들에게 우리 게임을 공유해',
            l2: ' SNS에서 알려 주세요!'
        },
        p2: '버그를 발견했거나 새로운 기능 제안이 있다면 알려 주세요!',
        bugs: {
            title: '버그',
            p1: '이상 동작, 오류, 버그는 공개 a|https://github.com/indexinteractive/|GitHub_저장소| 에 직접 제보해 주세요. 재현 단계 등 가능한 많은 정보를 포함해 주시면 도움이 됩니다.'
        },
        features: {
            title: '새로운 기능',
            p1: '새 기능, 개선 사항, 게임 아이디어가 있다면 a|https://github.com/indexinteractive/|GitHub_Discussions| 페이지에 새 토론을 만들어 알려 주세요.'
        }
    },
    share: {
        title: 'Shiritori | 재미있는 しらとり 게임으로 온라인 일본어 어휘를 쉽게 배우세요 - SHIRITORI',
        text: '친구 또는 랜덤 플레이어와 온라인으로 Shiritori를 즐기세요. 가입 없이 바로 플레이할 수 있습니다!',
    }
};
